module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0086.jpg?v=633f9b33";